import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Price, Size, Amenities, Actions, Specials } from '../columns';
import AvailableUnitsCount from './AvailableUnitsCount';
import styles from './ThemeThree.scss';

export default class ThemeThree extends React.Component {
  static propTypes = {
    facility: PropTypes.shape({}).isRequired,
    units: PropTypes.arrayOf(PropTypes.object).isRequired,
    actionButtons: PropTypes.shape({
      call: PropTypes.string.isRequired,
      moveIn: PropTypes.string.isRequired,
      reserve: PropTypes.string.isRequired,
    }).isRequired,
  };

  state = {
    isAscending: true,
    sortBy: 'size',
  };

  sortAscending = (label) => {
    this.sort(label, true);
  }

  sortDescending = (label) => {
    this.sort(label, false);
  }

  comparator = (a, b) => {
    const { sortBy, isAscending } = this.state;
    let value;
    switch (sortBy) {
      case 'size':
        value = b.area - a.area;
        break;
      case 'price':
        value = b.price - a.price;
        break;
      default:
        value = 0;
    }
    if (isAscending) {
      value *= -1;
    }
    return value;
  }

  sort(sortBy, isAscending) {
    this.setState({
      isAscending,
      sortBy,
    });
  }

  renderUnitGroup = (group) => {
    const { facility, actionButtons } = this.props;
    let { settings: { enableTieredPricing } } = facility;
    enableTieredPricing = enableTieredPricing && group.tiers?.length > 0;

    const feeFilter = {
      facilityId: facility?.id,
      unitGroupId: group?.id,
      unitTierId: enableTieredPricing ? group?.minimumPriceTierId : null,
      softwareProvider: facility?.settings?.softwareProvider,
    };

    const actionProps = {
      ...group,
      facility,
      isModal: false,
      renderAmenityIcons: true,
      renderButton: true,
      renderPriceInCard: true,
      renderSize: true,
    };

    return (
      <Col xs={12} sm={12} md={6} lg={6} xl={4} className={styles.card} key={`row-${group.id}`}>
        <div className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <span className={styles.size}><Size {...actionProps} /></span>
            <span className={styles.price}>
              <div className={styles.unitsLeft}><AvailableUnitsCount {...actionProps} /></div>
              <Price {...actionProps} feeFilter={feeFilter} />
            </span>
          </div>
          <div className={styles.cardBody}>
            <div><Amenities {...actionProps} /></div>
            <div><Specials {...actionProps} /></div>
          </div>
          <div className={styles.cardButtons}>
            <div>
              <Actions
                actionButtons={actionButtons}
                actionContainerClassName={styles.actionButtons}
                {...actionProps}
              />
            </div>
          </div>
        </div>
      </Col>
    );
  };

  render() {
    const { units } = this.props;
    const sortedUnits = units.slice(0).sort(this.comparator);

    return (
      <Row className="units-table-theme-three">
        {sortedUnits.map(this.renderUnitGroup)}
      </Row>
    );
  }
}
